document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.colfilter-title-wrapper').forEach(function(titleWrapper) {
    titleWrapper.addEventListener('click', function() {
      const container = titleWrapper.nextElementSibling;
      container.classList.toggle('active');

      const chevron = titleWrapper.querySelector('i');
      if (chevron.classList.contains('bi-dash-lg')) {
        chevron.classList.remove('bi-dash-lg');
        chevron.classList.add('bi-plus-lg');
      } else {
        chevron.classList.remove('bi-plus-lg');
        chevron.classList.add('bi-dash-lg');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const openFilterBtn = document.querySelector('.colfilter-btn');
  openFilterBtn.addEventListener('click', function() {
    document.querySelector('.collection-filters').classList.add('active');
    document.querySelector('.collection-filter-bck').classList.add('active');
  });

  const closeFilterBtn = document.querySelector('.colfil-close-btn');
  closeFilterBtn.addEventListener('click', function() {
    document.querySelector('.collection-filters').classList.remove('active');
    document.querySelector('.collection-filter-bck').classList.remove('active');
  });
});